<template>
  <Layout>
    <div class="row m-0" style="margin-top: 50px !important;margin-right:  -12px !important;margin-left:  -12px !important;">
      <div class="col-md-12 p-0" v-if="modelKySo.path">
        <PdfEditor :fileInfo="modelKySo" :pdf="`${modelKySo.path}`" />
      </div>
      <!--      <b-modal-->
      <!--          v-model="showModalClock"-->
      <!--          body-class="p-3"-->
      <!--          headerClass="justify-content-center"-->
      <!--          footerClass="bg-light py-1"-->
      <!--          centered-->
      <!--          hide-header-close-->
      <!--          no-close-on-backdrop-->
      <!--          size="md"-->
      <!--      >-->
      <!--        <template #modal-title>-->
      <!--          <div class="text-primary fw-bold text-center">-->
      <!--            <h4>Xác nhận ký tài liệu</h4>-->
      <!--          </div>-->
      <!--        </template>-->
      <!--       <CountDownClock />-->
      <!--        <template #modal-footer="{cancel}">-->
      <!--          <b-button class="btn bg-white me-2 text-primary px-5" @click="cancel()">Đóng</b-button>-->
      <!--&lt;!&ndash;          <b-button class="btn px-5 text-white" @click="addTextSignature" style="background-color: #3082c9;">Cập nhật</b-button>&ndash;&gt;-->
      <!--        </template>-->
      <!--      </b-modal>-->
    </div>
  </Layout>
</template>

<script>

import appConfig from "@/app.config.json";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import vue2Dropzone from "vue2-dropzone";
import PdfEditorTest from "@/components/pdfEditor/PdfEditorTest";
import CountDownClock from "@/components/countDownClock";
import {CURRENT_USER} from "@/helpers/currentUser";
import {notifyModel} from "@/models/notifyModel";
import PdfEditor from "@/components/pdfEditor/PdfEditor";

export default {
  name: "thietLapKySo",
  page: {
    title: "Ký số",
    meta: [{name: "description", content: appConfig.description}],
  },
  components:{
    PdfEditor,
    Layout,
    // CountDownClock
  },
  async created() {
    this.vanBanDiId = this.$route.params.id;
    await this.getVanBanDiById(this.$route.params.id);
  },
  computed:{
  },
  data() {
    return {
      title: "Ký số",
      apiUrl: process.env.VUE_APP_API_URL,
      apiViewFile: process.env.VUE_APP_API_URL + 'files/view/',
      files: null,
      showModalClock: true,
      vanBanDiId: null,
      modelKySo: {
        fileName: null,
        path: null,
        vanBanDiId: null
      }
    };
  },
  methods:{
   async getVanBanDiById(id){
      await this.$store.dispatch("vanBanDiStore/getById", id).then((res) => {
        if (res.resultCode == "SUCCESS") {
           this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage({resultString: "Tải văn bản thành công", resultCode: res.resultCode}));
          this.modelKySo.vanBanDiId = res.data.id;
          if (res.data.filePDF) {
            this.modelKySo.fileName = res.data.filePDF[0].fileName;
            this.modelKySo.path = this.apiViewFile + res.data.filePDF[0].fileId;
          } else if (res.data.file) {
            this.modelKySo.fileName = res.data.file[0].fileName;
            this.modelKySo.path = this.apiViewFile + res.data.file[0].fileId;
          }

          // if (value) {
          //   this.showModalThietLapKySoPhapLy = true;
          //   localStorage.setItem("kysophaply", JSON.stringify(this.modelKySo));
          // } else {
          //   this.showModalKySoPhapLy = true;
          //   this.modelKySo.userName = CURRENT_USER.USER_KY_SO.userNameKySo;
          //   this.modelKySo.password = CURRENT_USER.USER_KY_SO.userNameKySo;
          // }
        } else {
           this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        }
      });
    }
  }
}
</script>

<style scoped>

</style>